import type { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * One row in a home-screen list (holiday, event, announcement, leave request): a soft icon tile,
 * two text blocks, and an optional trailing element. Shared so every list aligns the same way.
 */
export function ListRow({
  icon,
  primary,
  secondary,
  trailing,
  chevron = false,
}: {
  icon: ReactNode;
  primary: ReactNode;
  secondary?: ReactNode;
  trailing?: ReactNode;
  chevron?: boolean;
}) {
  return (
    <li className="flex items-center gap-3 rounded-lg border border-border bg-surface px-3 py-3">
      <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-accent-subtle text-accent">
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-fg">{primary}</p>
        {secondary && <p className="truncate text-xs text-fg-muted">{secondary}</p>}
      </div>
      {trailing}
      {chevron && <ChevronRight className="size-4 shrink-0 text-fg-subtle" aria-hidden="true" />}
    </li>
  );
}
